import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { addAttendance } from "src/redux/api/_hr_attendance.api";
import { AttendanceForm } from "src/schemas/add-attendance";
import { todayAttendanceKeys } from "./useFetchTodayAttendance";

export const useAttendanceMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: AttendanceForm) => addAttendance(values),
    onSuccess: (res) => {
      if (res.message?.toLowerCase() === "success") {
        toast.success("Attendance Updated!");
      }
      
      queryClient.invalidateQueries({ queryKey: todayAttendanceKeys.all });
    },
    onError: (error) => {
      toast.error("Failed to Update Attendance!");
      console.error(error);
    },
  });
};